import { Box, IconButton, Tooltip, Chip } from "@mui/joy";
import { Info as InfoIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

/**
 * Info cell renderer - navigates to edit organization page
 */
export function Info(props: any) {
    const navigate = useNavigate();
    const { value } = props;

    const handleClick = () => {
        navigate(`/admin/organizations/${value}`);
    };

    return (
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"} height={"100%"}>
            <Tooltip title="View details" placement="top">
                <IconButton
                    size="sm"
                    variant="soft"
                    color="primary"
                    onClick={handleClick}
                    sx={{ "--IconButton-size": "32px" }}
                >
                    <InfoIcon size={16} />
                </IconButton>
            </Tooltip>
        </Box>
    );
}

/**
 * Status chip component with color coding
 */
export function StatusChip({ isActive }: { isActive: boolean }) {
    const config = isActive
        ? { color: "success" as const, label: "Active" }
        : { color: "neutral" as const, label: "Inactive" };

    return (
        <Chip
            variant="soft"
            color={config.color}
            size="md"
            sx={{ borderRadius: "4px", border: "1px solid", borderColor: "divider" }}
        >
            {config.label}
        </Chip>
    );
}

/**
 * Status cell renderer
 */
export function StatusCellRenderer(props: any) {
    const { value } = props;
    // Data grid passes boolean or 1/0, convert to boolean
    const isActive = value === true || value === 1 || value === "1";
    return <StatusChip isActive={isActive} />;
}
